import * as React from 'react';
import CutomCommitieeCard from '../components/CustomCommitieeCard';
import CustomHeader from '../components/CustomHeader';
import CustomSubheader from '../components/CustomSubheader';
import teamMember from '../assets/Images/team.jpg';
import { Divider } from '@mui/material';

const Team = () => {
  return (
    <div
      style={{
        padding: '20px',
        maxWidth: '90%',
        textAlign: 'center',
        margin: 'auto',
        marginTop: '40px'
      }}
    >
      <CustomHeader value='Organizing Committee' />
      <CustomSubheader value='Steering Committee' />

      <div
        style={{
          display: 'flex',
          justifyContent: 'center',
          flexWrap: 'wrap', // Allows cards to wrap on smaller screens
          margin: 'auto',
          marginBottom: '40px',
          gap: '40px',
        }}
      >
        <CutomCommitieeCard
          image={'https://uom.lk/sites/default/files/center/datasearch/images/dr.uthayasanker.jpg' || 'https://cdn.pixabay.com/photo/2015/10/05/22/37/blank-profile-picture-973460_960_720.png'}
          name={'Dr. Uthayasanker Thayasivam'}
          Position={'General Chair'}
        />
      </div>
      <div
        style={{
          display: 'flex',
          justifyContent: 'center',
          flexWrap: 'wrap', // Allows cards to wrap on smaller screens
          margin: 'auto',
          marginBottom: '40px',
          gap: '80px',
        }}
      >
        <CutomCommitieeCard
          image={'https://lms.uom.lk/staff_web/34372.jpg' || 'https://cdn.pixabay.com/photo/2015/10/05/22/37/blank-profile-picture-973460_960_720.png'}
          name={'Dr. Thanuja Ambegoda'}
          Position={'Program Chair'}
        />
        <CutomCommitieeCard
          image={'https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcTnQqt8JiwXqzoSTZB2OoItNQFGTjDbDn2nzcdqnd_pgOpSrFy4FCoyfNvwo7Jj1sbSB30&usqp=CAU' || 'https://cdn.pixabay.com/photo/2015/10/05/22/37/blank-profile-picture-973460_960_720.png'}
          name={'Dr. Buddhika Karunarathne'}
          Position={'Publications Chair'}
        />
        <CutomCommitieeCard
          image={'https://lms.uom.lk/staff_web/38257.jpg'}
          name={'Dr. Chathuranga Hettiarachchi'}
          Position={'Publications Chair'}
        />
      </div>
      <div
        style={{
          display: 'flex',
          justifyContent: 'center',
          flexWrap: 'wrap', // Allows cards to wrap on smaller screens
          margin: 'auto',
          marginBottom: '40px',
          gap: '80px',
        }}
      >
        <CutomCommitieeCard
          image={'https://files.cse.mrt.ac.lk/images/pro_pic_20220311_152004.jpeg'}
          name={'Dr. Adeesha Wijayasiri'}
          Position={'Industry Relations Chair'}
        />
        <CutomCommitieeCard
          image={'https://lms.uom.lk/staff_web/10376.jpg'}
          name={'Dr. Nisansa de Silva'}
          Position={'Publicity & Communications Chair'}
        />
        <CutomCommitieeCard
          image={'https://lms.uom.lk/staff_web/24087.jpg'}
          name={'Dr. Sandareka Wickramanayake'}
          Position={'Workshops & Tutorials Chair'}
        />

      </div>

      {/* <Divider
        textAlign='left'
        sx={{ color: 'text.secondary', marginBottom: '20px' }}
      >
        Chair
      </Divider>
      <div
        style={{
          display: 'flex',
          justifyContent: 'center',
          flexWrap: 'wrap', // Allows cards to wrap on smaller screens
          margin: 'auto',
          marginBottom: '20px',
          gap: '20px',
        }}
      >
        <CutomCommitieeCard
          image='https://avatars.githubusercontent.com/u/119396480?v=4'
          name={'Udara Wijesinghe'}
          Position={'Chair'}
        />
      </div>

      <Divider
        textAlign='left'
        sx={{ color: 'text.secondary', marginBottom: '20px' }}
      >
        Co - Chair
      </Divider>
      <div
        style={{
          display: 'flex',
          justifyContent: 'center',
          flexWrap: 'wrap', // Allows cards to wrap on smaller screens
          margin: 'auto',
          marginBottom: '20px',
          gap: '40px',
        }}
      >
        <CutomCommitieeCard
          image='https://avatars.githubusercontent.com/u/105097461?v=4'
          name={'Udara Wijesinghe'}
          Position={'Chair'}
        />
        <CutomCommitieeCard
          image='https://avatars.githubusercontent.com/u/86506927?v=4'
          name={'Udara Wijesinghe'}
          Position={'Chair'}
        />
      </div>

      <Divider
        textAlign='left'
        sx={{ color: 'text.secondary', marginBottom: '20px' }}
      >
        Organizing Committee
      </Divider>
      <div
        style={{
          display: 'flex',
          justifyContent: 'center',
          flexWrap: 'wrap', // Allows cards to wrap on smaller screens
          margin: 'auto',
          marginBottom: '20px',
          gap: '40px',
          //   maxWidth: '1200px',
        }}
      >
        <CutomCommitieeCard
          image='https://avatars.githubusercontent.com/u/55075132?v=4'
          name={'Udara Wijesinghe'}
          Position={'Chair'}
        />
        <CutomCommitieeCard
          image='https://avatars.githubusercontent.com/u/104646586?v=4'
          name={'Udara Wijesinghe'}
          Position={'Chair'}
        />
        <CutomCommitieeCard
          image='https://avatars.githubusercontent.com/u/114894532?v=4'
          name={'Udara Wijesinghe'}
          Position={'Chair'}
        />
        <CutomCommitieeCard
          image={teamMember}
          name={'Udara Wijesinghe'}
          Position={'Chair'}
        /> 
      </div>*/}
    </div>
  );
};

export default Team;
